// e23 digital animation
(function () {
	'use strict';

	var CHUNKS = {"logo-e":[{"d":"M221.30,-9.14 L233.35,-14.59","w":12.92,"l":13.23},{"d":"M231.98,-13.75 L237.30,-17.39 L242.86,-23.24","w":27.02,"l":14.52},{"d":"M241.93,-22.10 L248.17,-34.28","w":34.47,"l":13.7},{"d":"M247.68,-32.97 L250.66,-41.14 L249.38,-46.22","w":47.36,"l":13.94},{"d":"M249.77,-44.88 L247.51,-51.48 L242.84,-56.84","w":47.66,"l":14.09},{"d":"M243.99,-55.91 L237.93,-60.14 L231.81,-62.45","w":38.08,"l":13.93},{"d":"M233.27,-61.95 L227.41,-63.51 L219.00,-64.13","w":31.43,"l":14.5},{"d":"M220.62,-64.07 L206.10,-63.45","w":28.64,"l":14.54},{"d":"M207.58,-63.54 L201.19,-62.75 L193.99,-60.52","w":30.04,"l":13.97},{"d":"M195.35,-61.06 L190.07,-58.60 L183.22,-53.69","w":35.3,"l":14.25},{"d":"M184.45,-54.82 L178.90,-49.27 L175.58,-43.77","w":38.63,"l":14.27},{"d":"M176.23,-45.08 L171.28,-32.10","w":41.52,"l":13.89},{"d":"M171.78,-33.56 L167.99,-19.95","w":47.7,"l":14.13},{"d":"M168.35,-21.41 L167.97,-19.35 L170.33,-7.72","w":47.77,"l":13.96},{"d":"M170.09,-9.06 L172.03,-2.03 L175.06,3.86","w":46.04,"l":13.92},{"d":"M174.37,2.65 L182.19,14.50","w":45.1,"l":14.2},{"d":"M181.66,13.00 L185.27,26.61","w":41.88,"l":14.08},{"d":"M184.89,25.11 L186.23,28.57 L192.20,31.02 L196.05,31.17","w":41.3,"l":14.01},{"d":"M194.42,31.11 L202.70,31.43 L209.00,32.86","w":40.6,"l":14.75},{"d":"M207.39,32.50 L221.33,35.56","w":45.36,"l":14.27},{"d":"M219.70,35.50 L233.63,35.15","w":45.23,"l":13.93},{"d":"M185.65,28.25 L178.59,34.78 L175.12,36.57","w":41.3,"l":13.53},{"d":"M176.47,35.88 L164.78,43.42","w":39.08,"l":13.91},{"d":"M166.00,42.58 L155.71,52.24","w":45.29,"l":14.12},{"d":"M156.64,51.09 L149.09,62.49","w":48.03,"l":13.67},{"d":"M149.74,61.18 L144.96,73.73","w":49.05,"l":13.42},{"d":"M145.31,72.26 L141.97,85.75","w":51.41,"l":13.89},{"d":"M142.33,84.28 L140.17,97.81","w":55.73,"l":13.7},{"d":"M139.93,96.32 L141.76,110.16","w":55.73,"l":13.96},{"d":"M141.52,108.67 L144.86,121.82","w":54.21,"l":13.57},{"d":"M144.32,120.47 L150.06,132.68","w":53.0,"l":13.49},{"d":"M149.37,131.47 L158.42,142.18","w":51.19,"l":14.03},{"d":"M157.28,141.10 L163.32,145.63 L168.99,148.22","w":45.32,"l":13.78},{"d":"M167.53,147.57 L173.23,149.42 L181.18,150.47","w":38.19,"l":14.01},{"d":"M179.56,150.26 L193.77,150.22","w":35.32,"l":14.21},{"d":"M192.29,150.31 L206.12,148.63","w":35.05,"l":13.93},{"d":"M204.62,149.01 L211.36,147.06 L217.25,144.03","w":37.95,"l":13.64},{"d":"M215.89,144.86 L227.17,136.42","w":44.05,"l":14.09},{"d":"M226.09,137.42 L234.79,126.81","w":47.11,"l":13.72},{"d":"M234.16,127.96 L239.81,115.75","w":48.25,"l":13.46},{"d":"M239.31,117.21 L241.20,110.48 L239.53,103.90","w":48.16,"l":13.78},{"d":"M239.92,105.40 L235.38,92.64","w":42.62,"l":13.54},{"d":"M235.92,93.99 L232.36,86.75 L228.98,82.33","w":31.43,"l":13.64},{"d":"M229.82,83.40 L225.28,78.48 L220.23,75.18","w":18.93,"l":12.73}],"logo-2":[{"d":"M310.64,-10.45 L305.72,-12.67 L303.20,-15.31 L302.53,-19.25","w":27.75,"l":13.04},{"d":"M302.45,-17.86 L306.24,-30.47","w":27.75,"l":13.17},{"d":"M305.59,-29.25 L309.76,-35.29 L315.14,-38.90","w":24.59,"l":13.82},{"d":"M313.78,-38.28 L319.52,-40.47 L327.42,-41.30","w":21.81,"l":14.09},{"d":"M325.92,-41.10 L333.35,-41.53 L340.26,-40.46","w":23.34,"l":14.43},{"d":"M338.79,-40.82 L344.74,-38.55 L350.70,-33.63","w":31.16,"l":14.09},{"d":"M349.58,-34.81 L353.29,-29.59 L355.14,-22.67","w":32.15,"l":13.57},{"d":"M354.92,-24.07 L356.42,-16.19 L355.10,-10.97","w":34.87,"l":13.41},{"d":"M355.47,-12.34 L353.17,-5.50 L350.07,-0.24","w":33.94,"l":13.32},{"d":"M350.88,-1.45 L346.00,3.86 L340.45,7.87","w":33.66,"l":14.06},{"d":"M341.68,7.10 L329.33,13.54","w":31.23,"l":13.92},{"d":"M330.70,12.92 L317.97,18.35","w":27.17,"l":13.85},{"d":"M319.33,17.73 L306.87,23.60","w":24.6,"l":13.78},{"d":"M308.09,22.97 L296.41,30.83","w":23.21,"l":14.08},{"d":"M297.50,29.78 L292.44,35.77 L290.81,41.12","w":23.5,"l":13.43},{"d":"M291.18,39.88 L288.40,50.18 L286.23,51.87","w":32.74,"l":13.41},{"d":"M287.32,50.95 L278.46,61.48","w":31.07,"l":13.76},{"d":"M279.11,60.26 L273.91,71.54","w":14.71,"l":12.42},{"d":"M288.40,50.18 L290.10,51.52 L300.67,50.56","w":32.49,"l":12.78},{"d":"M299.19,50.62 L306.31,50.31 L312.46,48.83","w":21.8,"l":13.46},{"d":"M311.11,49.18 L324.26,46.97","w":23.7,"l":13.34},{"d":"M322.77,47.16 L336.32,45.95","w":26.77,"l":13.6},{"d":"M334.82,46.15 L343.29,45.77 L348.24,47.29","w":28.98,"l":13.65},{"d":"M346.79,46.79 L353.01,49.36 L358.29,53.13","w":27.63,"l":13.22},{"d":"M357.15,52.23 L361.81,56.52 L364.79,61.70","w":19.13,"l":12.3}],"logo-3":[{"d":"M419.97,233.51 L414.06,233.37 L407.25,230.70","w":25.07,"l":13.22},{"d":"M408.44,231.44 L406.96,230.41 L404.59,223.90 L404.74,218.87","w":33.24,"l":13.76},{"d":"M404.44,220.35 L406.96,211.18 L409.32,207.49","w":32.51,"l":13.9},{"d":"M408.44,208.67 L412.73,204.09 L419.68,200.68","w":26.11,"l":14.02},{"d":"M418.20,201.13 L423.08,199.80 L432.39,199.21","w":21.44,"l":14.39},{"d":"M430.77,199.21 L439.49,199.80 L444.67,201.42","w":21.81,"l":14.17},{"d":"M443.34,200.83 L449.55,204.53 L453.84,209.85","w":27.72,"l":14.06},{"d":"M453.10,208.67 L456.20,215.03 L457.83,221.54","w":29.36,"l":13.78},{"d":"M457.53,220.06 L458.27,224.05 L456.06,233.66","w":29.85,"l":13.93},{"d":"M456.35,232.18 L454.28,239.58 L451.47,245.05","w":24.62,"l":13.83},{"d":"M452.21,243.87 L450.14,246.82 L447.18,256.44","w":23.5,"l":13.67},{"d":"M448.07,255.25 L447.48,256.44 L442.15,255.40 L434.46,255.40","w":26.57,"l":14.44},{"d":"M436.09,255.40 L422.49,254.07","w":19.49,"l":13.67},{"d":"M447.48,256.44 L448.66,259.84 L455.02,267.53","w":27.06,"l":13.58},{"d":"M454.28,266.34 L456.79,270.93 L459.16,279.36","w":28.39,"l":13.98},{"d":"M458.86,277.73 L461.23,288.67 L460.64,291.63","w":33.4,"l":14.21},{"d":"M460.94,290.15 L458.86,298.58 L456.35,303.31","w":33.97,"l":14.04},{"d":"M457.09,301.98 L452.36,308.34 L447.33,312.19","w":33.71,"l":14.26},{"d":"M448.51,311.45 L442.89,314.41 L435.35,315.88","w":30.84,"l":14.04},{"d":"M436.83,315.74 L430.32,316.18 L422.34,315.15","w":27.15,"l":14.57},{"d":"M423.96,315.29 L416.57,313.81 L410.80,310.71","w":28.57,"l":14.09},{"d":"M412.13,311.60 L405.48,305.98 L402.96,300.95","w":30.66,"l":14.33},{"d":"M403.41,302.28 L400.45,291.19 L401.04,288.67","w":30.89,"l":14.06},{"d":"M400.60,290.15 L404.00,280.84 L407.11,278.32","w":30.66,"l":13.91},{"d":"M405.63,278.91 L410.51,277.73 L418.94,278.91","w":24.57,"l":13.53}],"scribble":[{"d":"M300.70,377.90 L299.90,368.50","w":16.09,"l":9.43},{"d":"M299.90,369.60 L300.20,359.60","w":26.28,"l":10.0},{"d":"M300.10,360.70 L301.60,351.00","w":35.88,"l":9.82},{"d":"M301.20,352.00 L307.30,344.50","w":39.31,"l":9.67},{"d":"M306.50,345.20 L314.50,339.80","w":39.35,"l":9.65},{"d":"M313.60,340.30 L322.20,336.40","w":39.29,"l":9.44},{"d":"M321.30,336.80 L330.40,334.20","w":46.99,"l":9.46},{"d":"M329.40,334.40 L339.10,333.00","w":46.77,"l":9.8},{"d":"M338.00,333.10 L347.90,332.80","w":46.94,"l":9.9},{"d":"M346.90,332.70 L356.60,333.80","w":46.2,"l":9.76},{"d":"M355.60,333.60 L365.20,335.20","w":46.15,"l":9.73},{"d":"M364.20,334.90 L373.40,337.50","w":46.87,"l":9.56},{"d":"M372.40,337.20 L381.20,340.60","w":39.93,"l":9.43},{"d":"M380.30,340.20 L388.90,344.20","w":41.38,"l":9.48},{"d":"M388.00,343.80 L396.60,347.80","w":43.54,"l":9.48},{"d":"M395.60,347.40 L404.40,351.00","w":44.53,"l":9.51},{"d":"M403.50,350.70 L412.50,353.50","w":44.69,"l":9.43},{"d":"M411.50,353.30 L421.00,355.20","w":44.77,"l":9.69},{"d":"M419.90,355.10 L429.60,356.40","w":45.4,"l":9.79},{"d":"M428.60,356.30 L438.30,355.70","w":45.47,"l":9.72},{"d":"M437.30,355.80 L446.80,354.00","w":43.65,"l":9.67},{"d":"M445.90,354.20 L454.80,351.10","w":41.35,"l":9.42},{"d":"M453.90,351.50 L462.10,346.80","w":38.5,"l":9.45},{"d":"M461.30,347.30 L468.60,340.80","w":34.13,"l":9.77},{"d":"M467.90,341.50 L473.70,333.80","w":28.29,"l":9.64},{"d":"M473.20,334.70 L477.20,326.10","w":20.03,"l":9.48},{"d":"M476.90,327.10 L478.40,318.00","w":11.66,"l":9.22}]};

	var ORDER     = ["logo-e", "logo-2", "logo-3", "scribble"];
	var PEN_MS    = 0.91;  // ms per unit of pen travel, PER GLYPH — lower is faster
	var LIFT_MS   = 90;   // pause between glyphs (pen lift)
	var SETTLE_MS = 220;  // final ink settle
	var MIN_GLYPH_MS = 120; // floor so a short glyph never completes in 0 frames

	var NS = 'http://www.w3.org/2000/svg';
	var uid = 0;

	function ease(t) { return t * t * (3 - 2 * t); }

	function setup(svg) {
		var id = 'e23logo' + (++uid);
		var defs = svg.querySelector('defs');
		if (!defs) {
			defs = document.createElementNS(NS, 'defs');
			svg.insertBefore(defs, svg.firstChild);
		}

		var hosts = ORDER.map(function (key) {
			return { key: key, el: svg.querySelector('[data-part="' + key + '"]') };
		}).filter(function (h) { return h.el && CHUNKS[h.key]; });
		if (!hosts.length) { return null; }

		var settle = document.createElementNS(NS, 'g');
		settle.setAttribute('opacity', '0');
		Array.prototype.forEach.call(svg.children, function (child) {
			if (child === defs) { return; }
			var copy = child.cloneNode(true);
			Array.prototype.forEach.call(copy.querySelectorAll('[data-part]'), function (n) {
				n.removeAttribute('data-part');
			});
			if (copy.hasAttribute && copy.hasAttribute('data-part')) { copy.removeAttribute('data-part'); }
			settle.appendChild(copy);
		});
		svg.appendChild(settle);

		// Each glyph is built as ONE continuous timeline: every chunk's path
		// is placed at its cumulative position along the glyph's total pen
		// travel, and a single requestAnimationFrame loop (in play()) picks
		// a "distance traveled so far" and updates every chunk's
		// stroke-dashoffset from that one number. This matters because the
		// previous version ran one tween() per CHUNK (~40 chunks per
		// glyph), and each tween only resolves inside a rAF callback --
		// which fires once per screen refresh (~16.7ms @ 60Hz) no matter
		// how short its requested duration is. That put a hard floor of
		// (chunk count) x (one frame) on the whole animation, completely
		// independent of any speed setting. Driving all chunks in a glyph
		// from one shared timeline removes that floor entirely.
		var groups = hosts.map(function (h) {
			var maskId = id + '-' + h.key;
			var mask = document.createElementNS(NS, 'mask');
			mask.setAttribute('id', maskId);
			mask.setAttribute('maskUnits', 'userSpaceOnUse');

			var b = h.el.getBBox();
			var m = Math.max(b.width, b.height);
			mask.setAttribute('x', b.x - m);
			mask.setAttribute('y', b.y - m);
			mask.setAttribute('width', b.width + 2 * m);
			mask.setAttribute('height', b.height + 2 * m);

			var cum = 0;
			var items = CHUNKS[h.key].map(function (c) {
				var p = document.createElementNS(NS, 'path');
				p.setAttribute('d', c.d);
				p.setAttribute('stroke', '#fff');
				p.setAttribute('stroke-width', c.w);
				p.setAttribute('fill', 'none');
				p.setAttribute('stroke-linecap', 'round');
				p.setAttribute('stroke-linejoin', 'round');
				mask.appendChild(p);
				var L = p.getTotalLength();
				p.style.strokeDasharray = L + ' ' + (L + 8);
				p.style.strokeDashoffset = L + 1.5;
				var item = { el: p, L: L, start: cum, end: cum + L };
				cum += L;
				return item;
			});

			defs.appendChild(mask);
			h.el.setAttribute('mask', 'url(#' + maskId + ')');
			return { host: h.el, items: items, total: cum, ms: Math.max(MIN_GLYPH_MS, cum * PEN_MS) };
		});

		return { groups: groups, settle: settle };
	}

	// Advances every chunk in ONE glyph from a single elapsed-time value.
	function setGlyphProgress(group, distance) {
		group.items.forEach(function (it) {
			var local = distance - it.start;
			var offset;
			if (local <= 0) {
				offset = it.L + 1.5;                // not reached yet
			} else if (local >= it.L) {
				offset = -1.5;                       // fully drawn
			} else {
				offset = it.L - local;               // mid-stroke
			}
			it.el.style.strokeDashoffset = Math.max(0, offset);
		});
	}

	function tween(ms, step) {
		return new Promise(function (resolve) {
			var t0 = null;
			(function frame(ts) {
				if (t0 === null) { t0 = ts; }
				var t = Math.min(1, (ts - t0) / ms);
				step(ease(t), t);
				if (t < 1) { requestAnimationFrame(frame); } else { resolve(); }
			})(performance.now());
		});
	}

	function wait(ms) {
		return new Promise(function (r) { setTimeout(r, ms); });
	}

	function play(state) {
		var chain = Promise.resolve();
		state.groups.forEach(function (g) {
			chain = chain.then(function () {
				return tween(g.ms, function (e) {
					setGlyphProgress(g, e * g.total);
				});
			}).then(function () {
				return wait(LIFT_MS);
			});
		});
		return chain.then(function () {
			return tween(SETTLE_MS, function (e) {
				state.settle.setAttribute('opacity', e.toFixed(3));
			});
		}).then(function () {
			state.groups.forEach(function (g) { g.host.removeAttribute('mask'); });
		});
	}

	function init() {
		if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
			return;
		}
		Array.prototype.forEach.call(
			document.querySelectorAll('svg[data-logo-animate]'),
			function (svg) {
				try {
					var state = setup(svg);
					if (state) { play(state); }
				} catch (err) {
					Array.prototype.forEach.call(
						svg.querySelectorAll('[mask]'),
						function (n) { n.removeAttribute('mask'); }
					);
					if (window.console) { console.warn('E23 logo animation skipped:', err); }
				}
			}
		);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();